import alertBarStyles from './alert-bar';

// JW:2021-07-08 - ADO:4838 - Inline helpers to prevent load order issues
var helpers = {
  addClassToAllElements: function addClassToAllElements (elements, clss, index) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add(`${clss}${index}`);
    }
  },
  isInEditMode: function isInEditMode () {
    return document.body.classList.contains('pagemode-edit');
  }
}

var editMode = document.querySelector('body.pagemode-edit');
var alertBars = document.querySelectorAll('.alert-bar');
var alertBarHolder = document.querySelector('div.alert-bar__holder');
createAlertBarCarousel();
if (!editMode) {
  attachClickEvent()
}
function createAlertBarCarousel() {
  if (alertBars.length > 1) {
    return new Swiper('.alert-bar__swiper-container', { loop: !1, slidesPerView: 1, allowTouchMove: !helpers.isInEditMode(), pagination: { el: '.alert-bar__swiper-pagination', type: 'bullets' }, navigation: { nextEl: '.alert-bar__swiper-button-next', prevEl: '.alert-bar__swiper-button-prev' } })
  } else if (alertBarHolder) { alertBarHolder.classList.add('singleAlertBar') }
}
function setCookies() {
  for (var alertBarIdx = 0; alertBarIdx < alertBars.length; alertBarIdx++){
    let alertBar = alertBars[alertBarIdx]; cookies.setCookie('pods-alertBar-' + alertBar.getAttribute('data-alertid'), !0)
  }
}
function attachClickEvent() {
  [...alertBars].map((alertBar, index) => {
    document.querySelector('.alert-bar__closer').addEventListener("click", (e) => { setCookies(); alertBarHolder.classList.add('dismissed') })
  })
}
